import { queryFee } from 'store/reducers-common/Fee/query.ts'
import { queryLeaderboard } from 'store/reducers-common/Leaderboard/query.ts'
import { poolSlice } from 'store/reducers-common/Pool/slice.ts'

import { queryAssets } from './Assets/query'
import { queryAuth } from './Auth/query'
import { localStorageMiddleware, setUser, sliceUser } from './Auth/slice'
import { sliceColorScheme } from './ColorScheme/slice'
import { queryDictionary } from './Dictionary/query'
import { sliceFund } from './Fund/slice.ts'
import { queryFunds } from './Funds/query'
import { setCurrentFund, sliceFunds } from './Funds/slice'
import { infoMiddleware, queryInfo } from './Info/query'
import { setAppData, setTokenData, sliceAppInfo } from './Info/slice'
import { queryPools } from './Pools/query'
import { queryReferrals } from './Referrals/query'
import { sessionExpiredMiddleware } from './sessionExpiredMiddleware'
import { sliceSocket } from './Socket/slice.ts'
import { queryTransaction } from './Transaction/query'
import { queryUnlimit } from './Unlimit/query'

export { setAppData, setCurrentFund, setTokenData, setUser }

export const reducersCommon = {
  appInfo: sliceAppInfo.reducer,
  colorScheme: sliceColorScheme.reducer,
  fund: sliceFund.reducer,
  pool: poolSlice.reducer,
  [queryAssets.reducerPath]: queryAssets.reducer,
  [queryAuth.reducerPath]: queryAuth.reducer,
  [queryDictionary.reducerPath]: queryDictionary.reducer,
  [queryFee.reducerPath]: queryFee.reducer,
  [queryFunds.reducerPath]: queryFunds.reducer,
  [queryInfo.reducerPath]: queryInfo.reducer,
  [queryLeaderboard.reducerPath]: queryLeaderboard.reducer,
  [queryPools.reducerPath]: queryPools.reducer,
  [queryReferrals.reducerPath]: queryReferrals.reducer,
  [queryTransaction.reducerPath]: queryTransaction.reducer,
  [queryUnlimit.reducerPath]: queryUnlimit.reducer,

  socket: sliceSocket.reducer,
  user: sliceUser.reducer,
  userFunds: sliceFunds.reducer,
}

export type ReducersCommon = typeof reducersCommon

export const middlewareCommon = [
  queryPools.middleware,
  queryReferrals.middleware,
  queryTransaction.middleware,
  queryInfo.middleware,
  infoMiddleware.middleware,
  queryDictionary.middleware,
  queryAuth.middleware,
  queryFunds.middleware,
  queryFee.middleware,
  queryAssets.middleware,
  queryLeaderboard.middleware,
  queryUnlimit.middleware,
  localStorageMiddleware,
  sessionExpiredMiddleware,
]

export type MiddlewareCommon = typeof middlewareCommon
